
<table class="table table-borderless table-striped table-hover">
  <thead>
    <tr>
      <th translate>USERNAME</th>
      <th translate>PASSWORD</th>
      <th translate>ACCESS</th>
      <th translate></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of data">
      <td>
        {{ user.username }}
      </td>
      <td>****************</td>
      <td>
        @for (access of user.accessList; track access.entity) {
            @if(access.read || access.write){
                {{access.entity}}; 
            }
        }
      </td>
      <td class="text-right actions">
        <gung-button
            classes="btn-outline-primary btn-sm mr-1"
            label="{{ 'EDIT' | translate }}"
            [onClick]="edit.bind(this, user)"
        />
        <gung-button
            classes="btn-outline-primary btn-sm"
            label="{{ 'DELETE' | translate }}"
            [onClick]="delete.bind(this, user)"
        />
      </td>
    </tr>
  </tbody>
</table>
